import { css } from "lit";

export default css`
    :host {
        display: flex;
        font-family: 'Press Start 2P', cursive;
        color: white;
        background-image: url(/assets/img/rooms/startscreen.png);
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 100%;
    }

    .number {
        text-align: center;
        font-size: 25px;
        margin-bottom: 5px;
    }
    
    .outer-container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        gap: 5rem;
    }

    .container {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        gap: 4rem;
    }

    .scoreboard {
        padding: 32px;
        border-radius: 8px;
        background-color: #212738;
        box-shadow: 0 0 60px rgba(0, 0, 0, 0.75);
        width: 20rem;
    }

    .title {
        font-size: 32px;
        margin-top: 0;
        margin-bottom: 24px;
        text-align: center;
    }

    .user-title {
        font-size: 20px;
        margin-bottom: 10px;
    }

    .score-list .score-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        font-size: 15px;
    }

    .score-item span:first-child {
        margin-right: 2rem;
    }

    .start-game-button {
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        background-color: #34d399;
        cursor: pointer;
        transition: background-color 300ms;
    }

    .start-game-button:hover {
        background-color: #4ade80;
    }

    .start-box {
        padding: 32px;
        border-radius: 8px;
        background-color: #212738;
        box-shadow: 0 0 60px rgba(0, 0, 0, 0.75);
    }
    
    .button-box {
        display: flex;
        flex-direction: column;
        min-width: 20%;
    }

    .retro-input {
        outline: none;
        padding: 7px 0 7px 14px;
        border-radius: 14px;
        border-style: solid;
        border-width: 4px;
        border-image-slice: 2;
        border-image-source: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='6'><path d='M0 2h2v2H0zM2 0h2v2H2zM4 2h2v2H4zM2 4h2v2H2z' fill='%230c639c' /></svg>");
        background-color: #209cee;
        font-weight: 700;
        color: white;
        width: auto;
    }

    .retro-input::placeholder {
        color: lightgray;
    }

    .action-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    
    .start-button {
        margin: auto;
    }
    
    .form-button {
        padding: 0 5px 5px 5px;
    }

    .start-button, .action-button, .form-button {
        padding: 10px 5px 10px 5px;
        color: white;
        text-align: center;
        border-radius: 14px;
        border-style: solid;
        border-width: 4px;
        border-image-slice: 2;
        border-image-source: url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='6' height='6'><path d='M0 2h2v2H0zM2 0h2v2H2zM4 2h2v2H4zM2 4h2v2H2z' fill='%230c639c' /></svg>");
        position: relative;
        cursor: pointer;
        background-color: #209cee;
    }

    .start-button:hover, .action-button:hover, .form-button:hover {
        background-color: #1190e3;;
    }

    .start-button:after, .action-button:after, .form-button:after {
        content: '';
        position: absolute;
        z-index: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        box-shadow: inset -4px -4px #1081cb;
    }
    
    .box-items {
        display: flex;
        flex-direction: column;
        gap: 2rem;
    }

    @keyframes pulse {
        0% {
            background-color: rgba(165, 165, 165, 0.1);
        }
        50% {
            background-color: rgba(165, 165, 165, 0.3);
        }
        100% {
            background-color: rgba(165, 165, 165, 0.1);
        }
    }

    .skeleton {
        animation: pulse 1.5s ease-in-out infinite;
        background-color: rgba(165, 165, 165, 0.1);
        border-radius: 4px;
        margin: 8px 0;
    }

    .skeleton-text {
        height: 16px;
        width: 90%;
    }

    .skeleton-box {
        height: 20px;
        width: 100%;
    }
    
    .form-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        margin-top: 2rem;
        margin-bottom: 2rem;
    }
    
    .action-container {
        margin-bottom: 1rem;
    }

    .valid {
        color: green;
    }

    .invalid {
        color: red;
    }

    .password-validation {
        font-size: 15px;
    }
`;